import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Notes } from '@app/core/Enum/note';
import { CommonService } from '@app/core/Services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-note49',
  templateUrl: './note49.component.html',
  styleUrls: ['./note49.component.scss'],
})
export class Note49Component implements OnInit {
  note49Form: FormGroup;
  @Input() triggerEditData: Observable<any>;

  constructor(public commonService: CommonService) {}

  ngOnInit(): void {
    this.setForm();
    this.triggerEditData?.subscribe((data) => {
      if (
        data.noteId === Notes.Note49 &&
        data.response.userInputData !== null &&
        data.response.userInputData !== undefined &&
        data.response.userInputData.data !== null &&
        data.response.userInputData.data !== undefined
      ) {
        this.editNotes49(data.response.userInputData.data);
      }
    });
  }

  editNotes49(res): void {
    this.note49Form.patchValue({
      textbox1: res.textbox1 ? res.textbox1 : '',
    });
  }

  setForm(): void {
    this.note49Form = new FormGroup({
      textbox1: new FormControl(''),
    });
  }
}